/**
 * @flow
 * @relayHash f40b54490f44b2a995fb89655e9ec6e9
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type LogoutButton_LogOut_MutationVariables = {|
  input: {
    ppjwt?: ?string;
    clientMutationId?: ?string;
  };
|};

export type LogoutButton_LogOut_MutationResponse = {|
  +logOut: ?{|
    +token: ?{|
      +token: string;
    |};
  |};
|};
*/


/*
mutation LogoutButton_LogOut_Mutation(
  $input: LogOutInput!
) {
  logOut(input: $input) {
    token {
      token
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "LogOutInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutButton_LogOut_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "LogOutInput!"
          }
        ],
        "concreteType": "LogOutPayload",
        "name": "logOut",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PingPongJWT",
            "name": "token",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "token",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "LogoutButton_LogOut_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "LogOutInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "LogoutButton_LogOut_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "LogOutInput!"
          }
        ],
        "concreteType": "LogOutPayload",
        "name": "logOut",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PingPongJWT",
            "name": "token",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "token",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation LogoutButton_LogOut_Mutation(\n  $input: LogOutInput!\n) {\n  logOut(input: $input) {\n    token {\n      token\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Container/__generated__/LogoutButton_LogOut_Mutation.graphql.js